import React from 'react'
import Typeeffect from './Typeeffect'
import { MdVerified } from "react-icons/md";
import {FaSquareGithub,FaFacebook,FaWhatsapp,FaLinkedin} from "react-icons/fa6"
import {SiGmail} from "react-icons/si"
function Annotation() {

  return (
    <div>
      <div className="container annotation my-7 border">
       <div className="row " style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
        
         <div  style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
            <img  src="https://avatars.githubusercontent.com/u/79055019?v=4" className="mx-auto  d-block" style={{width:"100px",height:"100px",borderRadius:"100%" , border: "4px solid #123e54",
  boxShadow: "0 0 2px 2px #1bff00"}} alt="..."/>
         </div>
         
       </div>
       <div className="row">
     
        <h1 className="title">Nejarul Islam<MdVerified/> </h1>

       </div>
       {/* <div className="row" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
        <img style={{width:"10rem",height:"10rem", display:"flex",alignItems:"center",justifyContent:"center"}} src="https://thumbs.gfycat.com/MistyMeekCaimanlizard-size_restricted.gif" alt="" srcset="" />
       </div> */}
       <div className="row">
        <Typeeffect/>
       </div>

       <div className="row">
        <div className="col-md-4 "></div>
        <div className="col-md-4  d-flex anchor justify-content-between">
            <a className='list-group-item list-group-item-action anchor-1 pt-0' href="https://github.com/nejaruli4460" target="_blank" rel="noopener noreferrer"><FaSquareGithub  style={{}}/></a>
            <a className='list-group-item list-group-item-action anchor-2 pt-0' href="https://www.facebook.com/ahmedrani.ar" target="_blank" rel="noopener noreferrer"><FaFacebook style={{}}/></a>
            <a className='list-group-item list-group-item-action anchor-3 pt-0' href="https://api.whatsapp.com/send?phone=+918609850867" target="_blank" rel="noopener noreferrer"><FaWhatsapp style={{}}/></a>
            <a className='list-group-item list-group-item-action anchor-4 pt-0' href="mailto:nejarulislam45@gmail.com" target="_blank" rel="noopener noreferrer"><SiGmail style={{}}/></a>
            <a className='list-group-item list-group-item-action anchor-5 pt-0' href="http://" target="_blank" rel="noopener noreferrer"><FaLinkedin style={{}}/></a>
        </div>
        <div className="col-md-4 "></div>
       </div>
      </div>
    </div>
  )
}

export default Annotation
